import { cn } from './utils';

type CibliLogoProps = {
  className?: string;
  imgClassName?: string;
};

export function CibliLogo({ className, imgClassName }: CibliLogoProps) {
  return <img src="/logo.svg" alt="Cibli" className={cn('h-10', imgClassName)} />;
}
